import React from 'react';
import { Storage, Code, MailOutline, Bolt } from '@mui/icons-material';
import SectionLabel from './SectionLabel';

/* A single downward arrow between two rows of the pipeline. */
function DownArrow() {
  return (
    <svg className="fnflow__down" width="12" height="36" viewBox="0 0 12 36" focusable="false" aria-hidden="true">
      <path d="M6 0 V 26" fill="none" stroke="var(--navy)" strokeWidth="1.5" />
      <polygon points="1,25 11,25 6,35" fill="var(--navy)" />
    </svg>
  );
}

/* Top-to-bottom pipeline: two sources merge into one computation, which feeds
   one output. Laid out vertically so it holds its shape in a narrow column. */
function FunctionFlowDiagram() {
  return (
    <div className="diagram diagram--panel fnflow">
      <SectionLabel className="fnflow__label">Example function: earned-to-incurred</SectionLabel>

      <div className="fnflow__sources">
        <div className="fnflow__node">
          <span className="fnflow__icon" aria-hidden="true">
            <Storage fontSize="inherit" />
          </span>
          <span>Premiums</span>
        </div>
        <div className="fnflow__node">
          <span className="fnflow__icon" aria-hidden="true">
            <Storage fontSize="inherit" />
          </span>
          <span>Claims</span>
        </div>
      </div>

      {/* The two source nodes are 132px wide with a 26px gap (290px row), so
          their centres sit at x = 66 and x = 224. */}
      <svg className="fnflow__merge" width="290" height="44" viewBox="0 0 290 44" focusable="false" aria-hidden="true">
        <g fill="none" stroke="var(--navy)" strokeWidth="1.5">
          <path d="M66 0 C 66 22, 145 12, 145 34" />
          <path d="M224 0 C 224 22, 145 12, 145 34" />
        </g>
        <polygon points="140,33 150,33 145,43" fill="var(--navy)" />
      </svg>

      <div className="fnflow__node fnflow__node--navy">
        <span className="fnflow__icon fnflow__icon--light" aria-hidden="true">
          <Code fontSize="inherit" />
        </span>
        <span>Compute earned-to-incurred</span>
      </div>

      <DownArrow />

      <div className="fnflow__node fnflow__node--outline-navy">
        <span className="fnflow__icon fnflow__icon--navy" aria-hidden="true">
          <MailOutline fontSize="inherit" />
        </span>
        <span>Email to underwriters</span>
      </div>

      <span className="fnflow__pill">
        <span className="fnflow__icon" aria-hidden="true">
          <Bolt fontSize="inherit" />
        </span>
        <span>Runs on demand, on a schedule, or when new data arrives</span>
      </span>

      <p className="diagram__caption">Built once, one click forever. Every run logged.</p>
    </div>
  );
}

export default FunctionFlowDiagram;
